var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(" 开启商家配送的商户需设置，在发货时可选用已添加的快递公司 ")]),_c('div',{staticClass:"cont"},[_vm._v(" div. ")])])
}]

export { render, staticRenderFns }